module.exports = __webpack_public_path__ + "img/u82.c557dc52.jpg";